import React from "react";

const TransactionModalFooter = ({ onClose, canSave, handleSubmit, mode }) => (
  <div className="p-4 border-t bg-gray-50 flex justify-end gap-2 rounded-b-lg">
    <button onClick={onClose} className="px-6 py-2 bg-gray-400 text-white rounded cursor-pointer hover:bg-gray-500 border-none transition-colors">
      Close
    </button>
    {canSave && (
      <button onClick={handleSubmit} className="px-8 py-2 bg-blue-600 text-white rounded font-bold cursor-pointer hover:bg-blue-700 border-none transition-colors">
        {mode === "add" ? "Save Assignment" : "Update Note"}
      </button>
    )}
  </div>
);

export default TransactionModalFooter;